const randomColors = [
  '#4b5563',
  '#dc2626',
  '#ca8a04',
  '#16a34a',
  '#2563eb',
  '#9333ea',
  '#db2777',
]
export const getRandomColorById = (id: string) => {
  const index =
    id.split('').reduce((prev, curr) => prev + curr.charCodeAt(0), 0) %
    randomColors.length

  return randomColors[index]
}
